import { createSelector } from "reselect";
import { propertyTypeAsString } from "view/formModels/helpers/propertyHelper";
import * as _ from "lodash";

const root = (state) => state.property;

const selectPageConfig = createSelector(root, (propertyState) => ({
  filter: propertyState.filter,
  page: propertyState.page,
}));

const selectRows = createSelector(root, (propertyState) => ({
  rows: propertyState.rows,
  unfilteredRows: propertyState.unfilteredRows,
  count: propertyState.count,
  tenants: propertyState.tenants,
  loadingUnfilteredRows: propertyState.loadingUnfilteredRows,
}));

const selectAvailableProperties = createSelector(root, (propertyState) => ({
  rows: propertyState.rows.filter((p) => !p.disabled),
  unfilteredRows: propertyState.unfilteredRows,
  count: propertyState.count,
  tenants: propertyState.tenants,
  loadingUnfilteredRows: propertyState.loadingUnfilteredRows,
}));

const selectUniqueBuildingNames = createSelector(root, (propertyState) => {
  const orderedPropertyNames = filterPropertyByPropertyName(
    propertyState.unfilteredRows,
    "name"
  );
  return {
    buildingNames: orderedPropertyNames,
  };
});
const selectUniqueBuildingNumbers = createSelector(root, (propertyState) => {
  const orderedPropertyNames = filterPropertyByPropertyName(
    propertyState.unfilteredRows,
    "number"
  );
  return {
    buildingNames: orderedPropertyNames,
  };
});

const selectActiveUniqueBuildingNames = createSelector(
  root,
  (propertyState) => {
    const orderedPropertyNames = filterPropertyByPropertyName(
      propertyState.unfilteredRows.filter((p) => !p.disabled),
      "name"
    );
    return {
      buildingNames: orderedPropertyNames,
    };
  }
);

const filterPropertyByPropertyName = (propertyList, propName) => {
  let mappedProp = propertyList.map((x) => x[propName]);
  let uniqueProperties = _.uniq(mappedProp);

  const mappedSelectOptions = uniqueProperties.map((p, i) => {
    return {
      id: i,
      label: p,
      value: p,
    };
  });
  const orderSelection = _.orderBy(mappedSelectOptions, ["label"], ["asc"]);
  return orderSelection;
};

const propertyOptions = createSelector(root, (propertyState) => {
  return _.orderBy(
    propertyState.unfilteredRows
      .filter((p) => !p.disabled)
      .map((property) => ({
        id: property.id,
        value: `${property.id}`,
        label: `${property.number} ${property.name} (${propertyTypeAsString(
          property.type
        )})`,
        number: property.number,
        name: property.name,
      })),
    ["name", "number"],
    ["asc", "asc"]
  );
});

const isLoadingRows = createSelector(
  root,
  (propertyState) => propertyState.loadingProperties
);

const selectFormState = createSelector(root, (propertyState) => ({
  showFormModal: propertyState.showFormModal,
  initialFormValue: propertyState.initialFormValue,
}));

const selectAllTenants = createSelector(
  root,
  (propertyState) => propertyState.tenants
);

export default {
  selectUniqueBuildingNumbers,
  selectUniqueBuildingNames,
  selectAvailableProperties,
  selectActiveUniqueBuildingNames,
  selectPageConfig,
  selectRows,
  isLoadingRows,
  selectFormState,
  selectAllTenants,
  propertyOptions,
};
